import axios from 'axios';
import config from '../../../config';
import Cookies from 'js-cookie';

const baseUrl = config.baseUrl; // URL base de tu API
const setPlanCompraEndpoint = '/api/financiero/registrarplandecomprassostenibilidad'; // Endpoint para enviar los planes de compra

// Crear una instancia de Axios con la configuración base
const api = axios.create({
    baseURL: baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Función para enviar el plan de compras al backend
 * @param {Object} planCompraData - JSON con la estructura del plan de compras
 * @returns {Promise<Object>} Respuesta del backend con status y mensaje
 */
export const registrarPlanCompraSostenibilidad = async (planCompraData) => {

    try {
        const response = await api.post(setPlanCompraEndpoint, planCompraData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });


        return response; // Devuelve los datos del servicio
    } catch (error) {
        console.error('❌ Error al enviar el plan de compras Sostenibilidad:', error.response?.data || error.message || error);

        return {
            status: error.response?.status || 500,
            message: error.response?.data?.message || '⚠️ Error al enviar el plan de compras Sostenibilidad. Verifique la conexión con el servidor.',
        };
    }
};
